export const UIProgressBar = ({ currentStep, totalSteps }) => (
  <div className="mb-8">
    <div className="flex justify-between items-center mb-2">
      <span className="text-sm text-gray-600">
        Étape {currentStep} sur {totalSteps}
      </span>
      <span className="text-sm text-gray-600">
        {Math.round((currentStep / totalSteps) * 100)}%
      </span>
    </div>
    <div className="w-full bg-gray-200 rounded-full h-2">
      <div
        className="bg-green-600 h-2 rounded-full transition-all duration-300"
        style={{ width: `${(currentStep / totalSteps) * 100}%` }}
      ></div>
    </div>
  </div>
);
